import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, Input, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';

import { SnCamera } from '@lib/api/entities';
import { SnCamerasAPI } from '@lib/api/services';

@Component({
  selector: 'sn-camera-list-share',
  templateUrl: './camera-list-share.component.component.html',
  styleUrls: ['./camera-list-share.component.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SnCameraListShareComponent implements OnInit, OnDestroy {
  @Input() public cameraIds: any[];

  public cameras: SnCamera[] = [];
  public viewCameras: boolean = false;

  private readonly _destroy$ = new Subject<void>();

  constructor(private readonly _camerasAPI: SnCamerasAPI) {}

  public ngOnInit(): void {
    this.cameraIds.forEach((item) => {
      this._camerasAPI
        .getCamera(item)
        .pipe(takeUntil(this._destroy$))
        .subscribe((camera: any) => {
          this.cameras.push(camera);
        });
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
